import React from 'react';
import Button from '@mui/material/Button';
import CustomLoader from './CustomLoader';
const classes = {
    buttonRoot: (theme) => ({
        textTransform: 'none',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        '&:hover.Mui-disabled, & .Mui-disabled': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.background.default,
            opacity: 0.5,
        },
    }),
    loaderRoot: (theme) => ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }),
};
export default function CustomButton({ buttonText, buttonLoading = false, loaderAttributes = {
    size: 20,
    thickness: 5,
}, buttonClassSX = {}, ...other }) {
    return (React.createElement(Button, { disableRipple: true, disableFocusRipple: true, sx: [classes.buttonRoot, ...(Array.isArray(buttonClassSX) ? buttonClassSX : [buttonClassSX])], ...other },
        buttonLoading && (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: loaderAttributes })),
        buttonText));
}
